import main from './module-main';
import deals from './module-deals';
import createUpdateDeal from './module-create-update-deal';
import successCriteria from './module-success-criteria';
import myPortfolio from './module-my-portfolio';
import admin from './admin/module-admin';
import profile from './module-profile';

export default {
	modules: {
		admin,
		main,
		deals,
		createUpdateDeal,
		successCriteria,
		myPortfolio,
		profile
	}
};
